module.exports = new __parcel__URL__("dark.340583c6.svg").toString();